import React from "react";
import classes from "./PageSummary.module.css";

const EngineeringPageSummary = () => {
  return (
    <section className={classes.summary}>
      <h2 style={{ fontWeight: "bold" }}>
        Welcome to the @one Alliance Project Viewer Engineering Page
      </h2>
      <p>
        Here you can access applications that are designed to assist you in
        completing or delivering tasks relating to delivery in Engineering
      </p>
      <p>
        This area is currently under development and more releases are planned
        over the coming weeks and months. Please check back regularly for new
        updates and look out for communications coming your way.
      </p>
      <p>
        For all questions, or to tell us what you think, please contact
        oneengineering@anglianwater.co.uk
      </p>
    </section>
  );
};

export default EngineeringPageSummary;
